import { useState, useEffect } from "react";
import { jwtFetch } from "./utils/apiClient";
import { useParams, useNavigate } from "react-router-dom";
import { config, priceFormat, numberFormat } from "./Components/Config";
import Menu from "./Components/Menu";
import Header from "./Components/Header";

const ProductDetail = () => {
  const { id_product } = useParams();
  const [product, setProduct] = useState(null);
  const [productMarginPrice, setProductMarginPrice] = useState('0');
  const [productMarginRate, setProductMarginRate] = useState('0');
  const crmUser = JSON.parse(localStorage.getItem('crmUser'));

  const navigate = useNavigate();

  useEffect(() => {
    getProduct();
  }, []);

  const getProduct = async () => {
    try {
      const requestProduct = {
        "id_product": id_product
      };
      const fetchProduct = await jwtFetch(config.ENDPOINT + 'get/product', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestProduct)
      });
      const responseProduct = await fetchProduct.json();
      if (responseProduct.status === 200) {
        setProduct(responseProduct.data[0]);
        setProductMarginPrice(parseFloat((responseProduct.data[0].product_price - responseProduct.data[0].product_cost).toFixed(3)));
        setProductMarginRate(responseProduct.data[0].product_price > 0 ? parseFloat(((responseProduct.data[0].product_price - responseProduct.data[0].product_cost) / responseProduct.data[0].product_price * 100).toFixed(3)) : 0);
      } else {
        alert(responseProduct.message);
      }
    } catch (error) {
      console.error('Error in getProduct:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  }

  return (
    <div id="product-detail">
      <div className="container-fluid p-0">
        <div className="row g-0 mh-100vh">
          <div className="col-md-2 border-end">
            <div className="d-md-flex d-none align-items-center justify-content-center p-1 h-48">
              <a className="h-100" href="/dashboard"><img className="h-100" src="/cuancuan.png" alt="PointStar" /></a>
            </div>
            <hr className="m-0" />
            <Menu active="product" />
          </div>
          <div className="col-md-10">
            <Header />
            <hr className="m-0" />
            <div className="main">
              <div className="p-4">

                <section className="mb-4">
                  <div className="d-flex align-items-center justify-content-between mb-3">
                    <div className="fs-24"><button className="btn btn-link" onClick={() => navigate(-1)}><i className="bi bi-arrow-left" /></button> Product Detail</div>
                    {crmUser.user_level === 'Admin' && (
                      <button className="btn btn-sm btn-outline-secondary" type="button" onClick={() => window.location.href = '/product/edit/' + id_product}><i className="bi bi-pencil me-1" /> Edit</button>
                    )}
                  </div>
                  {product ? (
                    <div className="row">
                      <div className="col-md-6">
                        <div className="row mb-2">
                          <div className="col-md-4 text-secondary">Category</div>
                          <div className="col-md-8">{product.category_name} <a href={"/product/category/detail/" + product.product_category_id}><i className="bi bi-link-45deg" /></a></div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-md-4 text-secondary">Subcategory</div>
                          <div className="col-md-8">{product.subcategory_name} <a href={"/product/category/subcategory/detail/" + product.product_subcategory_id}><i className="bi bi-link-45deg" /></a></div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-md-4 text-secondary">Name</div>
                          <div className="col-md-8">{product.product_name}</div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-md-4 text-secondary">Description</div>
                          <div className="col-md-8" style={{ whiteSpace: 'pre-wrap' }}>{product.product_description}</div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-md-4 text-secondary">Type</div>
                          <div className="col-md-8">{product.product_type}</div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-md-4 text-secondary">Unit</div>
                          <div className="col-md-8">{product.product_unit}</div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-md-4 text-secondary">Country</div>
                          <div className="col-md-8">{product.product_country}</div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-md-4 text-secondary">Currency</div>
                          <div className="col-md-8">{product.product_currency}</div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-md-4 text-secondary">Cost Price</div>
                          <div className="col-md-8">{priceFormat(product.product_cost, product.product_currency)}</div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-md-4 text-secondary">Selling Price</div>
                          <div className="col-md-8">{priceFormat(product.product_price, product.product_currency)}</div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-md-4 text-secondary">Margin ({priceFormat(productMarginRate)}%)</div>
                          <div className="col-md-8">{priceFormat(productMarginPrice, product.product_currency)}</div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-md-4 text-secondary">Status</div>
                          <div className="col-md-8"><span className={"badge bg-" + (product.product_status === 'Active' ? 'success' : 'danger')}>{product.product_status}</span></div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <p>No data</p>
                  )}
                </section>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetail;


